/* Sync the mobile purchase bar from the same variant state as the main offer. */
(function(){
 function init(){
  var offer=document.querySelector('[data-talu-duo]');
  var bar=document.querySelector('[data-talu-quick]');
  if(!offer||!bar)return;
  function sync(){
   var one=bar.querySelector('[data-quick-one]');
   var two=bar.querySelector('[data-quick-two]');
   var buy=offer.querySelector('[data-duo-buy]');
   var price=offer.dataset.singlePrice||'';
   var active=document.querySelector('.v-pill.is-active');
   var title=bar.dataset.productTitle+(active?' · '+active.textContent.trim():'');
   bar.querySelector('[data-quick-title]').textContent=title;
   one.textContent='Comprar 1 · '+price;
   two.textContent='Comprar 2 · '+offer.querySelector('[data-duo-total]').textContent+' · −10%';
   var oneOK=offer.dataset.singleAvailable==='true';
   var twoOK=buy.hasAttribute('href')&&buy.getAttribute('aria-disabled')!=='true';
   [[one,oneOK,offer.dataset.singleHref],[two,twoOK,buy.getAttribute('href')]].forEach(function(row){
    if(row[1]){row[0].setAttribute('href',row[2]);row[0].removeAttribute('aria-disabled');}
    else{row[0].removeAttribute('href');row[0].setAttribute('aria-disabled','true');}
   });
  }
  new MutationObserver(sync).observe(offer,{attributes:true,subtree:true,childList:true,attributeFilter:['href','aria-disabled','data-single-price','data-single-href','data-single-available']});
  sync();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();